import { useLayoutStore } from "/@/store/modules/layout";
import axios from "axios";
import { ElLoading, ElNotification } from "element-plus";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
let paramConfig = {};
let loading: { close(): void };
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: import.meta.env.VITE_API_URL as string | undefined,
  timeout: 60000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error: { message: string; response: any }) => {
  const { reomveStorage, tokenInvalidation } = useLayoutStore();
  // loading.close();
  let errMsg = error.message;
  if (error.response.status === 401) {
    errMsg = "登录过期，请重新登录";
    reomveStorage(true);
  }
  ElNotification({
    title: "请求失败",
    message: errMsg,
    type: "error",
  });
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  const { getStatus } = useLayoutStore();
  const isToken = (config.headers || {}).isToken === false;
  // loading = ElLoading.service({
  //   lock: true,
  //   text: "",
  //   spinner: "el-icon-loading",
  //   background: "rgba(225, 255, 255, 0.4)",
  // });
  const token = getStatus.ACCESS_TOKEN;
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token && !isToken) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  paramConfig = config;
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use((response) => {
  const { data } = response;
  // loading.close();
  if (paramConfig.url == "/base/comm/getWorkOrderAccountFansExcel") {
    if (response.headers["content-type"] == "application/force-download") {
      return {
        data: data,
        code: 1000,
      };
    } else {
      return {
        data: data,
        code: 1046,
      };
    }
  } else {
    if (data.code) {
      codeErrorHandler(data);
      return Promise.reject(new Error(data.message || "Error"));
    }

    return response.data;
  }
}, errorHandler);

// code异常处理
const codeErrorHandler = async (data) => {
  const { getStatus, logout, reomveStorage, tokenInvalidation } =
    useLayoutStore();
  let title = "请求失败";
  if (data.code === 401) {
    title = "身份认证失败";
    if (getStatus.ACCESS_TOKEN) {
      tokenInvalidation();
      reomveStorage(false);
    }
  }
  ElNotification({
    title,
    message: data.message,
    type: "error",
  });
};

export default request;
